export default "__VITE_ASSET__BzPM7GJS__"